<template>
	<section :id="['container-' + index + '-' + energyData.type]" :class="['container-' + energyData.type]">
		<div class="energy-table container-xl">
			<div class="row">
				<div :class="[energyData.config.showScala == true ? 'col-md' : 'col-12']">
					<div class="row">
						<div class="col-12">
							<h2 v-if="energyData.config.title">{{ energyData.config.title }}</h2>
						</div>
						
						<TableItemsComponent :tableData="energyData.config" :index="index" isMultiblock="true" />
					</div>
				</div>
	
				<div v-if="energyData.config.showScala == true && energyData.config.path" class="energy-image col-md-6 d-flex align-items-center justify-content-center">
					<img :src="energyData.config.path" alt="">
				</div>
			</div>
		</div>
	</section>
</template>

<script>

import TableItemsComponent from "./TableItemsComponent.vue"

export default {
	components: {
		TableItemsComponent,
	},
	
	props: {
		energyData: {
			type: Object
		},
		index: {
			type: Number
		},
	},
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/energydataComponent.scss";
</style>